import script from "./DownLoadDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownLoadDetail.vue?vue&type=script&setup=true&lang=ts"

import "./DownLoadDetail.vue?vue&type=style&index=0&id=29e805a4&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e805a4"]])

export default __exports__